// @core/api/endpoints/product/get_product.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ProductResponse,
} from '../../../types/product';

const BASE_PATH = '/product';

/**
 * Get product details
 * Retrieves complete information about a specific product including its capabilities, branding, and configuration.
 * @public This endpoint does not require authentication
 */
export async function GetProduct(
  product_id: string,
  options?: RequestOptions
): Promise<ProductResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/products/:product_id`;
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  const requestOptions = { ...options, skipAuth: true };
  return client.get<ProductResponse>(requestPath, { ...requestOptions });
}
